import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    avatar: {
      width: 40,
      height: 40,
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(),
    },
    icon: {
      right: '10px',
    },
    list: {
      marginTop: theme.spacing(0.2),
    },
    mainList: {
      padding: 0,
    },
    primaryContent: {
      fontSize: '0.875rem',
    },
    secondaryContent: {
      fontSize: '0.75rem',
    },
  };
};
